<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const i18nScope = 'components.sales_dashboard';

  const props = defineProps({
    collapsed: { type: Boolean, required: true },
    // Human-readable name of the section, for the button label
    section: { type: String, required: true },
    // id of the element that is shown or hidden
    controls: { type: String, default: null }
  });

  const emit = defineEmits(['toggle']);

  const label = computed(() => t(`${i18nScope}.${props.collapsed ? 'show_section' : 'hide_section'}`, { section: props.section }));
</script>

<template>
  <button
    type="button"
    class="btn btn-sm btn-outline-secondary"
    :aria-expanded="!collapsed"
    :aria-controls="controls"
    :aria-label="label"
    :title="label"
    @click="emit('toggle')"
  >
    <i class="bi" :class="collapsed ? 'bi-chevron-down' : 'bi-chevron-up'" aria-hidden="true"></i>
  </button>
</template>
